import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lead)?_c(VListItem,[_c(VListItemContent,[_c(VListItemSubtitle,[_vm._v(_vm._s(_vm.$t(`labels.${_vm.label}`)))]),_c(VListItemTitle,[_vm._v(_vm._s(_vm.lead.provider_lead_id))])],1),(_vm.$deal.isAllowed('atLeastManager'))?_c(VListItemAction,[_c(VBtn,{attrs:{"icon":"","small":"","to":_vm.goToLead()}},[_c(VIcon,{attrs:{"small":""}},[_vm._v(_vm._s(_vm.$vuetify.icons.values.view))])],1)],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }